import http from './http'

const ORDER_API = '/saas_order.php'

export function calcOrderPrice(proId) {
  return http.get(ORDER_API, {
    params: { action: 'calc_price', pro_id: proId }
  })
}

export function createOrder(payload) {
  const formData = new FormData()
  Object.keys(payload).forEach(key => {
    if (payload[key] !== undefined && payload[key] !== null) {
      formData.append(key, payload[key])
    }
  })
  return http.post(`${ORDER_API}?action=create_order`, formData)
}

export function payOrder(payload) {
  const formData = new FormData()
  formData.append('order_no', payload.order_no)
  formData.append('amount', payload.amount)
  formData.append('type', payload.type)
  return http.post(`${ORDER_API}?action=pay`, formData)
}

export function checkPayStatus(orderNo) {
  return http.get(ORDER_API, {
    params: { action: 'check_pay_status', order_no: orderNo }
  })
}

export function fetchOrderList(params = {}) {
  return http.get(ORDER_API, {
    params: {
      action: 'order_list',
      page: params.page || 1,
      pageSize: params.pageSize,
      status: params.status
    }
  })
}

export function updateOrderStatus(orderId, status) {
  const formData = new FormData()
  formData.append('order_id', orderId)
  formData.append('status', status)
  return http.post(`${ORDER_API}?action=update_status`, formData)
}

export function applyOrderRefund(orderId, reason) {
  const formData = new FormData()
  formData.append('order_id', orderId)
  formData.append('reason', reason)
  return http.post(`${ORDER_API}?action=apply_refund`, formData)
}
